<template>
  <power-wrapper :CurrRole="CurrRole">
    <div class="distributorList">
      <h3>推广链接</h3>
      <div class="refresh">成员可以为自己创建专属推广链接</div>
      <div class="showRemoved">
        <el-checkbox v-model="showDeleted" @change="getCheckValue">显示已删除的链接</el-checkbox>
      </div>
      <el-form :inline="true" :model="listQuery" label-width="100px">
        <el-form-item label="推广渠道">
          <el-select v-model="listQuery.promotionChannelCode" filterable placeholder="请选择推广渠道" @change="handleChannel">
            <el-option label="全部推广渠道" :value="null" />
            <el-option v-for="item in channelList" :key="item.id" :label="item.name" :value="item.promotionChannelCode" />
          </el-select>
        </el-form-item>
        <el-form-item label="推广位">
          <el-select v-model="listQuery.promotionPositionCode" filterable placeholder="请选择商品类型">
            <el-option label="全部推广位" :value="null" />
            <el-option v-for="item in promotionList" :key="item.id" :label="item.name" :value="item.promotionPositionCode" />
          </el-select>
        </el-form-item>
        <el-form-item label="归属人">
          <el-select v-model="listQuery.linkBelongerCode" filterable placeholder="请选择商品类型">
            <el-option label="全部归属人" :value="null" />
            <el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.agentCode" />
          </el-select>
        </el-form-item>
        <el-form-item label="推广链接ID">
          <el-input v-model="listQuery.promotionLinkCode" placeholder="输入推广链接ID查询" class="orderStyle" />
        </el-form-item>
        <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
        <div class="btns-style">
          <el-button class="down-code btnCreate" type="primary" icon="el-icon-download" @click="exportExcel('batchQrcode')">批量下载二维码</el-button>
          <!-- 下载组建 -->
          <DownExcel :listQuery="listQuery" :linkStatus="linkStatus" :total="total" :showDeleted="showDeleted" pageType="link" />
          <el-dropdown v-if="linkCreate" split-button type="primary" @click="create('create')" class="user-dropdown right-dropdown btn">
            创建推广链接
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <span @click="create('batchCreate')" class="sign-out dropdown-link">批量创建推广链接</span>
              </el-dropdown-item>
              <el-dropdown-item>
                <span @click="download()" class="sign-out dropdown-link">推广链接批量下载</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-form>
      <div style="margin-bottom:10px;">
        <el-radio-group v-model="linkStatus" @input="changeLinkStatus" type="primary">
          <el-radio-button label="1">推广中</el-radio-button>
          <el-radio-button label="0">已停用</el-radio-button>
        </el-radio-group>
      </div>
      <div style="margin-bottom:10px">
        <el-button style="margin:0px" type="primary" @click="batchDeactivatePromotedLinks">批量禁用</el-button>
      </div>
      <el-table v-loading="listLoading" :data="list" border fit highlight-current-row :header-cell-style="tableHeader" @selection-change="handleSelectionChange">
        <el-table-column v-if="linkStatus === '1'" type="selection" width="55"> </el-table-column>
        <el-table-column label="推广链接ID" align="center" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.promotionLinkCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广链接名称" align="center" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.promotionLinkName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广课程" align="center" width="160">
          <template slot-scope="{ row }">
            <span>{{ row.agentCourse.name }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广课程ID" align="center" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.courseId || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广位名称" align="center" width="160">
          <template slot-scope="{ row }">
            <span>{{ row.positionName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广渠道名称" align="center" width="160">
          <template slot-scope="{ row }">
            <span>{{ row.channelName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广位ID" align="center" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.promotionPositionCode || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="归属人" align="center" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.linkBelongerCode && Number(row.linkBelongerCode) !== 0 ? row.agentName : "无归属人" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广短链接" align="center" min-width="200">
          <template slot-scope="{ row }">
            <span :style="row.agentCourse && row.agentCourse.courseStatus ? 'text-decoration: line-through red;' : null">{{ row.shortLink }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" width="160">
          <template slot-scope="{ row }">
            <span>{{ row.ctime ? timestampToDate(row.ctime) : "" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="400px" align="center">
          <template slot-scope="{ row }">
            <div class="btnStyle" v-if="linkStatus === '1'">
              <el-button type="text" @click="edit(row)" style="color:#FF9900;">编辑</el-button>
              <el-button type="text" @click="deactivatePromotedLinks(row)" style="color:#FF9900;">停用</el-button>
              <el-button v-if="row.agentCourse && row.agentCourse.courseStatus === 0" type="text" style="color:#FF9900;" v-copy="row.shortLink" v-copy:callback="clipboardSuccessHandler"
                >复制短链接</el-button
              >
              <el-button type="text" @click="watchDetail(row)" style="color:#FF9900;">查看详情</el-button>
            </div>
            <div v-else-if="linkStatus === '0'">
              <el-button type="text" @click="enablePromotedLinks(row)" style="color:#FF9900;">启用</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNumber" :limit.sync="listQuery.pageSize" @pagination="getList" />
      <!-- 创建推广链接弹窗 -->
      <el-dialog :title="dialogType === 'batchCreate' ? '批量创建推广链接' : '创建推广链接'" :visible.sync="dialogVisible" width="630px" :before-close="cancelDialog">
        <el-form :model="editQuery" :rules="LevelSRules" label-width="130px" ref="linkRef">
          <el-form-item prop="promotionLinkName" v-if="dialogType !== 'batchCreate'" label="链接名称">
            <el-input type="text" v-model="editQuery.promotionLinkName" placeholder="请输入链接名称" class="selectWidth numrule" maxlength="50" />
          </el-form-item>
          <el-form-item prop="courseId" label="推广课程">
            <el-select v-model="editQuery.teamCourseId" filterable placeholder="选择推广课程" class="selectWidth" @change="getCourseInfo">
              <el-option v-for="item in courseList" :key="item.teamCourseId" :label="item.teamCourseName + '#' + item.id" :value="item.teamCourseId"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程描述" v-if="courseInfo.length > 0">
            <span>{{ (courseInfo[0] && courseInfo[0].courseDesc) || "--" }}</span>
          </el-form-item>
          <el-form-item label="落地页链接" v-if="courseInfo.length > 0">
            <span>{{ (courseInfo[0] && courseInfo[0].link) || "--" }}</span>
          </el-form-item>
          <el-form-item label="是否生成小程序码" v-if="courseInfo.length > 0">
            <span>{{ courseInfo[0] && courseInfo[0].info && courseInfo[0].info.showMiniprogram === "true" ? "是" : "否" }}</span>
          </el-form-item>
          <el-form-item prop="promotionChannelCode" label="推广渠道">
            <el-select v-model="editQuery.promotionChannelCode" filterable placeholder="选择推广渠道" class="selectWidth" @change="getChannelInfo">
              <el-option v-for="item in channelList" :key="item.id" :label="item.name" :value="item.promotionChannelCode"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="promotionPositionCode" label="推广位" v-if="channelCode">
            <el-select v-model="editQuery.promotionPositionCode" filterable placeholder="选择推广位" class="selectWidth">
              <el-option v-for="item in promotionList" :key="item.id" :label="item.name" :value="item.promotionPositionCode"> </el-option>
            </el-select>
            <p>如需要新的推广位，可点击<span class="toPosition" @click="toPosition">新建推广位</span></p>
          </el-form-item>
          <el-form-item v-if="dialogType === 'batchCreate'" prop="num" label="链接数量">
            <el-input type="number" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))" v-model="editQuery.num" placeholder="输入链接数量" class="selectWidth numrule" />
            <span class="red">最多创建20条推广链接</span>
          </el-form-item>
          <p v-if="dialogType === 'batchCreate'" class="attention"><i class="el-icon-warning-outline"></i><span>批量创建的推广链接无归属人</span></p>
          <el-form-item v-if="dialogType !== 'batchCreate'" prop="linkBelongerCode" label="链接归属人">
            <el-select v-model="editQuery.linkBelongerCode" filterable placeholder="选择链接归属人" class="selectWidth">
              <el-option v-for="item in teamListNew" :key="item.id" :label="item.name" :value="item.agentCode"> </el-option>
            </el-select>
            <div style="line-height:23px">
              {{ editQuery.linkBelongerCode === "all" ? "为全部成员分别创建一个专属链接" : editQuery.linkBelongerCode === 0 ? "与人无关的推广位，比如公众号底部菜单" : "" }}
            </div>
          </el-form-item>
          <el-form-item v-if="editQuery.linkBelongerCode === 'part'">
            <el-select v-model="editQuery.agentInfos" multiple filterable clearable placeholder="请输入成员姓名" class="selectWidth">
              <el-option v-for="item in allMembers" :key="item.id" :label="item.name + '(' + handlePhone(item.phone) + ')'" :value="item.agentCode" />
            </el-select>
            <div style="line-height:23px">可以指定多个成员</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelDialog">取 消</el-button>
          <el-button type="primary" @click="confirmDialog()">创 建</el-button>
        </span>
      </el-dialog>
      <!-- 推广链接详情弹窗 -->
      <el-dialog title="推广链接详情" :visible.sync="detailVisible" width="600px" :before-close="cancelDetail">
        <el-form label-width="110px">
          <el-form-item prop="name" label="推广链接ID">
            <span>{{ currentItem.promotionLinkCode || "--" }}</span>
          </el-form-item>
          <el-form-item label="推广链接名称">
            <span>{{ currentItem.promotionLinkName || "--" }}</span>
          </el-form-item>
          <el-form-item label="推广课程">
            <span>{{ (currentItem && currentItem.agentCourse && currentItem.agentCourse.name) || "--" }}</span>
          </el-form-item>
          <el-form-item label="课程描述">
            <span>{{ (currentItem && currentItem.agentCourse && currentItem.agentCourse.courseDesc) || "--" }}</span>
          </el-form-item>
          <el-form-item label="推广完整链接">
            <a :href="handleUrl(currentItem.detailLink)" target="_blank" rel="noopener noreferrer" class="blue">
              {{ currentItem.detailLink || "--" }}
            </a>
          </el-form-item>
          <el-form-item v-if="currentItem.info && currentItem.info.appId" label="小程序推广信息">
            <a :href="'https://wrpnn3mat2.feishu.cn/docx/BJKzd8a6MogqZHxbfKcc72NvnPc'" target="_blank" rel="noopener noreferrer" class="blue">小程序 AppId 和 Path 的使用</a>
          </el-form-item>
          <div v-if="currentItem.info && currentItem.info.appId" class="mp-container">
            <el-form-item label="AppId:" style="margin-bottom:0;">{{ currentItem.info.appId }}</el-form-item>
            <el-form-item label="Path:">{{ currentItem.info.path }}</el-form-item>
          </div>
          <el-form-item label="推广短链接">
            <a :href="currentItem.shortLink" target="_blank" rel="noopener noreferrer" class="blue">
              {{ currentItem.shortLink || "--" }}
            </a>
            <el-button class="filter-item filter-item-new" type="primary" v-copy="currentItem.shortLink" v-copy:callback="clipboardSuccessHandler">复制链接</el-button>
          </el-form-item>
          <el-form-item label="推广二维码" v-if="currentItem.shortLink">
            <ul class="qrcode_box">
              <li>
                <qrcode-vue :value="currentItem.shortLink" level="H" :size="150" id="qrcode" class="qrcode-style"></qrcode-vue>
                <el-button class="save-img" type="primary" @click="saveImg">保存二维码</el-button>
              </li>
              <li v-if="currentItem.poster">
                <img :src="getPosterImg(currentItem)" class="poster_img" height="150" alt="" />
                <a class="save-img" target="_blank" :href="getPosterImg(currentItem)">保存海报</a>
              </li>
            </ul>
            <ul v-if="currentItem.info.miniprogramImage" class="qrcode_box">
              <li>
                <img class="qrcode-style" style="width:168px;" :src="getMpQrcodeImg(currentItem.info.miniprogramImageKey)" alt="小程序二维码" />
                <el-button class="save-img" type="primary" @click="saveMiniprogramImg(currentItem.info.miniprogramImage)">保存二维码</el-button>
              </li>
              <li v-if="currentItem.poster">
                <img :src="getMpQrcodePosterImg(currentItem.poster, currentItem.info.miniprogramImageKey)" class="poster_img" height="150" alt="" />
                <a class="save-img" target="_blank" :href="getMpQrcodePosterImg(currentItem.poster, currentItem.info.miniprogramImageKey)">保存海报</a>
              </li>
            </ul>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="cancelDetail">关 闭</el-button>
        </span>
      </el-dialog>
      <!-- 编辑推广链接弹窗 -->
      <el-dialog title="编辑推广链接" :visible.sync="editVisible" width="600px" :before-close="cancelEdit">
        <el-form label-width="130px" :model="editItem" :rules="EditRules" ref="editRef">
          <el-form-item prop="promotionLinkName" label="链接名称">
            <el-input type="text" v-model="editItem.promotionLinkName" placeholder="请输入链接名称" class="selectWidth numrule" maxlength="50" />
          </el-form-item>
          <el-form-item label="推广课程">
            <span>{{ (editItem && editItem.agentCourse && editItem.agentCourse.name) || "--" }}</span>
          </el-form-item>
          <el-form-item label="课程描述">
            <span>{{ (editItem && editItem.agentCourse && editItem.agentCourse.courseDesc) || "--" }}</span>
          </el-form-item>
          <el-form-item label="落地页链接">
            <a :href="handleUrl(editItem.link)" target="_blank" rel="noopener noreferrer" class="blue">
              {{ editItem.link || "--" }}
            </a>
          </el-form-item>
          <el-form-item label="是否生成小程序码">
            <span>{{ editItem && editItem.info && editItem.info.showMiniprogram === "true" ? "是" : "否" }}</span>
          </el-form-item>
          <el-form-item label="推广渠道">
            {{ editItem.channelName || "--" }}
          </el-form-item>
          <el-form-item label="推广渠道">
            {{ editItem.positionName || "--" }}
          </el-form-item>
          <el-form-item label="链接归属人">
            {{ editItem.linkBelongerCode && Number(editItem.linkBelongerCode) !== 0 ? editItem.agentName : "无归属人" }}
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelEdit">取 消</el-button>
          <el-button type="primary" @click="editLink()">保 存</el-button>
        </span>
      </el-dialog>
      <!-- 推广链接批量下载 -->
      <el-dialog title="推广链接批量下载" :visible.sync="visibleDialog" :before-close="handleClose" :close-on-click-modal="false" top="3vh" width="700px">
        <div>
          <downLoad ref="childDown" @handleResult="handleClose"></downLoad>
        </div>
      </el-dialog>
    </div>
  </power-wrapper>
</template>

<script>
import Cookie from "js-cookie";
import { encode } from "js-base64";
import QrcodeVue from "qrcode.vue";
import { mapActions, mapGetters } from "vuex";

import DownExcel from "@/components/DownExcel/index";
import PowerWrapper from "@/components/PowerWrapper";
import Pagination from "@/components/Pagination/index";

import { exportExcel } from "@/services/downExcel";
import { getPromotionList } from "@/services/promotion";
import { getLinkList, getCourseList, getChannelList, getTeamList, editProduct, addProduct, deactivatePromotedLinks, enablePromotedLinks, batchDeactivatePromotedLinks } from "@/services/link";

import { delUndefined, timestampToDateTotal } from "@/utils/utils";
import { getTeamCode, getAgentCode, getTeamRole } from "@/utils/auth";

import downLoad from "./components/downLoad";
export default {
  name: "links",
  components: {
    Pagination,
    PowerWrapper,
    DownExcel,
    downLoad,
    QrcodeVue
  },
  data() {
    return {
      CurrRole: "links",
      list: [],
      showDeleted: false,
      listQuery: {
        pageSize: 10,
        pageNumber: 1,
        linkBelongerCode: null,
        promotionLinkCode: null,
        promotionChannelCode: null,
        promotionPositionCode: null
      },
      total: 1,
      listLoading: false,
      dialogVisible: false,
      detailVisible: false,
      editQuery: {
        id: null,
        teamCourseId: null,
        promotionPositionCode: null,
        promotionChannelCode: null,
        linkBelongerCode: getAgentCode(),
        num: null,
        agentInfos: []
      },
      linkStatus: "1",
      editItem: {},
      editVisible: false,
      allMembers: [],
      LevelSRules: {
        promotionLinkName: { required: true, message: "请输入链接名称", trigger: ["blur"] },
        teamCourseId: [{ required: true, message: "请选择推广课程", trigger: ["blur", "change"] }],
        promotionChannelCode: [{ required: true, message: "请选择推广渠道", trigger: ["blur", "change"] }],
        promotionPositionCode: [{ required: true, message: "请选择推广位", trigger: ["blur"] }],
        linkBelongerCode: [{ required: true, message: "请选择链接归属人", trigger: ["blur", "change"] }],
        num: [
          { required: true, message: "请填写链接数量", trigger: ["blur"] },
          {
            validator: (rule, val, cb) => {
              if (val <= 0) {
                this.editQuery.num = 1;
              } else if (val > 20) {
                this.editQuery.num = 20;
              } else {
                cb();
              }
            },
            trigger: ["blur"]
          }
        ]
      },
      EditRules: {
        promotionLinkName: { required: true, message: "请输入链接名称" }
      },
      courseList: [],
      channelList: [],
      promotionList: [],
      courseInfo: [],
      teamList: [],
      teamListNew: [],
      multipleSelection: [],
      channelCode: null,
      currentItem: {},
      downloadParam: {},
      dialogType: null,
      visibleDialog: false
    };
  },
  computed: {
    tableHeader() {
      return () => {
        return { "background-color": "#f5f5f5" };
      };
    },
    ...mapGetters(["linkCreate"])
  },
  created() {
    this.getList();
    // 获取推广渠道
    this.getChannelList();
    // 获取团队成员信息
    this.getTeamList();
    this.getSignature();
  },
  methods: {
    ...mapActions(["getOssSignature"]),
    async getSignature() {
      const data = await this.getOssSignature();
      this.ossParams = {
        ...this.ossParams,
        OSSAccessKeyId: data.id,
        signature: data.signature,
        policy: data.policy
      };
    },
    toPosition() {
      this.$router.push({ path: "/position/list" });
    },
    getCheckValue(value) {
      this.showDeleted = value;
      this.getList("search");
    },
    // 手机号隐藏中间4位
    handlePhone(tel) {
      const reg = /^(\d{3})\d{4}(\d{4})$/;
      return tel.replace(reg, "$1****$2");
    },
    handleUrl(url) {
      const newUrl = url && url.indexOf("http") === -1 && url.indexOf("https") === -1 ? `https://${url}` : url;
      return newUrl;
    },
    timestampToDate(time) {
      return timestampToDateTotal(time);
    },
    getCourseInfo(e) {
      if (e && this.courseList.length > 0) {
        this.courseInfo = this.courseList.filter(item => item.teamCourseId && Number(item.teamCourseId) === Number(e));
      }
    },
    getChannelInfo(e) {
      this.channelCode = e;
      this.getPromotionList(e);
    },
    getPromotionList(channelCode) {
      const params = {
        teamCode: getTeamCode(),
        channelCode: channelCode
      };
      getPromotionList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.data.length > 0 && res.data.errCode === 0) {
          this.editQuery.promotionPositionCode = res.data.data[0] && res.data.data[0].promotionPositionCode;
          this.promotionList = res.data.data;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove("staffToken");
          setTimeout(() => {
            this.$router.push({ path: "/login" });
          }, 3000);
        } else {
          this.promotionList = [];
          this.editQuery.promotionPositionCode = null;
        }
      });
    },
    getTeamList() {
      const params = {
        teamCode: getTeamCode()
      };
      getTeamList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0) {
          this.allMembers = res.data.data && res.data.data.length > 0 ? res.data.data.filter(item => Number(item.agentStatus) === 0) : [];
          let teamArr = [];
          // 角色身份
          if (Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2) {
            teamArr = [
              {
                agentCode: 0,
                name: "无归属人"
              }
            ];
            this.teamList = teamArr.concat(res.data.data);
          } else {
            teamArr = [
              {
                agentCode: getAgentCode(),
                name: "我的"
              },
              {
                agentCode: 0,
                name: "无归属人"
              }
            ];
            this.teamList = teamArr;
          }
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove("staffToken");
          setTimeout(() => {
            this.$router.push({ path: "/login" });
          }, 3000);
        } else {
          this.teamList = [];
        }
      });
    },
    getCourseList() {
      getCourseList().then(res => {
        if (res && res.data && res.data.data && res.data.data.list && res.data.data.list.length > 0 && res.data.errCode === 0) {
          // teamCourseId只作为选择器的唯一ID使用，提交接口时还是使用id
          this.editQuery.teamCourseId = res.data.data.list[0] && res.data.data.list[0].teamCourseId;
          this.courseInfo = [res.data.data.list[0]];
          this.courseList = res.data.data.list;
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove("staffToken");
          setTimeout(() => {
            this.$router.push({ path: "/login" });
          }, 3000);
        } else {
          this.courseList = [];
        }
      });
    },
    getChannelList() {
      const teamCode = getTeamCode();
      getChannelList(teamCode).then(res => {
        if (res && res.data && res.data.data && res.data.data.length > 0 && res.data.errCode === 0) {
          this.editQuery.promotionChannelCode = res.data.data[0] && res.data.data[0].promotionChannelCode;
          this.channelList = res.data.data;
          if (this.editQuery.promotionChannelCode) {
            this.channelCode = this.editQuery.promotionChannelCode;
            if (this.dialogVisible) {
              this.getPromotionList(this.editQuery.promotionChannelCode);
            }
          }
        } else if (res.data && res.data.errCode === 1016) {
          Cookie.remove("staffToken");
          setTimeout(() => {
            this.$router.push({ path: "/login" });
          }, 3000);
        } else {
          this.channelList = [];
        }
      });
    },
    getList(btnName) {
      this.listLoading = true;
      const params = {
        ...this.listQuery,
        pageNumber: btnName === "search" ? 1 : this.listQuery.pageNumber,
        teamCode: getTeamCode(),
        agentCode: getAgentCode(),
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0,
        showDeleted: this.showDeleted,
        linkStatus: this.linkStatus
      };
      getLinkList(delUndefined(params)).then(res => {
        if (res && res.data && res.data.data && res.data.errCode === 0 && res.data.data.list && res.data.data.list.length > 0) {
          this.listLoading = false;
          const { list, total } = res.data.data;
          this.list = list;
          this.total = total;
          if (btnName === "search") {
            this.listQuery.pageNumber = 1;
          }
        } else if (res.data && res.data.errCode === 1016) {
          this.$message({ type: "error", message: "登录时效已过期，请重新登录" });
          Cookie.remove("staffToken");
          setTimeout(() => {
            this.$router.push({ path: "/login" });
          }, 3000);
        } else {
          this.listLoading = false;
          this.list = [];
          this.total = 0;
        }
      });
    },
    handleSearch() {
      this.getList("search");
    },
    create(type) {
      if (this.$refs.linkRef) this.$refs.linkRef.clearValidate();
      // 弹窗类型
      this.dialogType = type;
      this.dialogVisible = true;
      // 获取推广课程
      this.getCourseList();
      // 再次查询归属人
      this.getTeamList();
      // 再次查询推广渠道
      this.getChannelList();
      // 清空部分成员
      this.editQuery.agentInfos = [];
      this.editQuery.promotionPositionCode = null;
      this.editQuery.num = null;
      // 链接归属人默认值
      this.editQuery.linkBelongerCode = getAgentCode();
      this.teamListNew =
        Number(getTeamRole()) === 1 || Number(getTeamRole()) === 2
          ? [
            {
              agentCode: getAgentCode(),
              name: "我的专属链接"
            },
            {
              agentCode: "part",
              name: "给部分成员分别创建专属链接"
            },
            {
              agentCode: "all",
              name: "给全部成员分别创建专属链接"
            },
            {
              agentCode: 0,
              name: "无归属人"
            }
          ]
          : [
            {
              agentCode: getAgentCode(),
              name: "我的专属链接"
            },
            {
              agentCode: 0,
              name: "无归属人"
            }
          ];
    },
    edit(item) {
      this.editVisible = true;
      this.editItem = Object.assign({}, item);
    },
    async editLink() {
      await this.$refs.editRef.validate();
      const { id, promotionLinkName } = this.editItem;
      const res = await editProduct({
        type: "PUT",
        params: {
          id,
          promotionLinkName,
          teamCode: getTeamCode()
        }
      });
      const { errCode, errMsg } = res.data;
      if (errCode === 0) {
        this.$message({ type: "success", message: "编辑成功" });
        this.cancelEdit();
        this.getList();
      } else if (errCode === 1016) {
        this.$message({ type: "error", message: "登录时效已过期，请重新登录" });
        Cookie.remove("staffToken");
        setTimeout(() => {
          this.$router.push({ path: "/login" });
        }, 3000);
      } else {
        this.$message({ type: "error", message: errMsg });
      }
    },
    watchDetail(item) {
      this.detailVisible = true;
      this.currentItem = item;
    },
    cancelDialog() {
      this.dialogVisible = false;
      this.editQuery.promotionLinkName = "";
      // 再次查询归属人
      this.getTeamList();
    },
    cancelDetail() {
      this.detailVisible = false;
    },
    cancelEdit() {
      this.editVisible = false;
      this.$refs.editRef.clearValidate();
    },
    confirmDialog() {
      const { editQuery, channelList, courseList, promotionList, teamListNew, allMembers, dialogType } = this;
      const { teamCourseId, promotionPositionCode, promotionChannelCode, linkBelongerCode, id, agentInfos, num, promotionLinkName } = editQuery;
      const courseId = this.courseInfo && this.courseInfo[0] && this.courseInfo[0].id;
      const choosedChannelArr = promotionChannelCode && channelList.length > 0 ? channelList.filter(item => item.promotionChannelCode && item.promotionChannelCode === promotionChannelCode) : [];
      const courseArr = courseId && courseList.length > 0 ? courseList.filter(item => item.teamCourseId && item.teamCourseId === teamCourseId) : [];
      const positonArr = courseId && promotionList.length > 0 ? promotionList.filter(item => item.promotionPositionCode && item.promotionPositionCode === promotionPositionCode) : [];
      const belognArr = linkBelongerCode && teamListNew.length > 0 ? teamListNew.filter(item => item.agentCode && item.agentCode === linkBelongerCode) : [];
      const agentInfosArr = agentInfos && agentInfos.length > 0 && allMembers.length > 0 ? allMembers.filter(item => agentInfos.indexOf(item.agentCode) !== -1) : [];
      this.$refs.linkRef.validate(async valid => {
        if (valid) {
          const params = {
            courseId,
            courseName: courseArr.length > 0 ? courseArr[0] && courseArr[0].name : null,
            channelGroupId: courseArr.length > 0 ? courseArr[0] && courseArr[0].channelGroupId : null,
            channelGroupName: courseArr.length > 0 ? courseArr[0] && courseArr[0].channelGroupName : null,
            promotionPositionCode,
            positionName: positonArr.length > 0 ? positonArr[0] && positonArr[0].name : null,
            promotionChannelCode,
            channelName: choosedChannelArr.length > 0 ? choosedChannelArr[0] && choosedChannelArr[0].name : null,
            link: this.courseInfo && this.courseInfo[0] && this.courseInfo[0].link,
            num: dialogType === "batchCreate" ? Number(num) : null,
            linkBelongerCode: dialogType === "batchCreate" ? 0 : linkBelongerCode === "all" ? null : linkBelongerCode,
            agentName: belognArr.length > 0 ? belognArr[0] && belognArr[0].name : null,
            teamCode: getTeamCode(),
            createAgentCode: getAgentCode(),
            all: linkBelongerCode === "all" ? 1 : null,
            agentInfos: agentInfosArr.length > 0 ? agentInfosArr : null
          };
          if (dialogType === "batchCreate") {
            this.$confirm(`您确定要创建${num}条推广链接吗?`, "创建链接", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              confirmButtonClass: "btnFalses"
            })
              .then(() => {
                this.createOrEditApi(id, params);
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消创建"
                });
              });
          } else {
            this.createOrEditApi(id, { ...params, promotionLinkName });
          }
        } else {
          this.$message({ type: "error", message: "请完整填写信息" });
        }
      });
    },
    // 创建或编辑接口
    createOrEditApi(id, params) {
      if (this.isEdit) {
        // 编辑
        editProduct({
          type: "PUT",
          params: {
            id: id ? Number(id) : null,
            ...delUndefined(params)
          }
        }).then(res => {
          if (res.data && res.data.errCode === 0) {
            this.$message({ type: "success", message: "编辑推广链接成功" });
            this.getList();
            this.dialogVisible = false;
          } else if (res.data && res.data.errCode === 1016) {
            this.$message({ type: "error", message: "登录时效已过期，请重新登录" });
            Cookie.remove("staffToken");
            setTimeout(() => {
              this.$router.push({ path: "/login" });
            }, 3000);
          } else {
            this.$message({ type: "error", message: res.data.errMsg });
          }
        });
      } else {
        addProduct({
          type: "POST",
          params: {
            ...delUndefined(params)
          }
        }).then(res => {
          if (res.data && res.data.errCode === 0) {
            this.$message({ type: "success", message: "创建推广链接成功" });
            this.editQuery.promotionLinkName = "";
            this.getList();
            this.dialogVisible = false;
            // 创建完成，下载弹窗
            if (this.dialogType === "batchCreate") {
              this.$confirm(`点击确定，下载批量生产的推广链接汇总表`, "创建完成！", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                confirmButtonClass: "btnFalses"
              })
                .then(() => {
                  // 调用下载接口
                  this.exportExcel("excel", res.data.data);
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "已取消下载"
                  });
                });
            }
          } else if (res.data && res.data.errCode === 1016) {
            this.$message({ type: "error", message: "登录时效已过期，请重新登录" });
            Cookie.remove("staffToken");
            setTimeout(() => {
              this.$router.push({ path: "/login" });
            }, 3000);
          } else {
            this.$message({ type: "error", message: res.data.errMsg });
          }
        });
      }
    },
    alertBox(msg) {
      this.$confirm(msg, "", {
        distinguishCancelAndClose: true,
        showConfirmButton: false,
        cancelButtonText: "关闭",
        cancelButtonClass: "btnClose"
      })
        .then(() => {
          console.log();
        })
        .catch(() => {
          console.log();
        });
    },
    clipboardSuccessHandler() {
      this.$notify({
        title: "提示：",
        message: "复制成功",
        type: "success"
      });
    },
    handleChannel(value) {
      this.channelCode = value;
      if (value) {
        this.getPromotionList(value);
      } else {
        this.promotionList = [];
        this.listQuery.promotionPositionCode = null;
      }
    },
    // 批量下载弹窗
    download() {
      this.visibleDialog = true;
      if (this.$refs.childDown) {
        this.$refs.childDown.getListNew();
      }
    },
    handleClose() {
      this.visibleDialog = false;
    },
    saveImg() {
      const cvs = document.getElementById("qrcode").getElementsByTagName("canvas");
      const a = document.createElement("a");
      a.href = cvs[0].toDataURL("image/png").replace("image/png", "image/octet-stream");
      a.download = "qrcode.png";
      a.click();
    },
    getPosterImg({ poster, shortLinkQrCode }) {
      const imgPath = shortLinkQrCode.replace(/^https?\:\/\/img\.hetao101\.com\//, "");
      console.log("imgPath ", imgPath);
      const qrcode = `${imgPath}?x-oss-process=image/resize,w_${186},h_${186}`;
      const posterimg = `image_${encode(qrcode)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/\=/g, "")},g_se,x_55,y_34`;
      return `${poster}?x-oss-process=image/resize,w_750/watermark,${posterimg}`;
    },
    getMpQrcodeImg(key) {
      return `https://img.hetao101.com/${key}`;
    },
    saveMiniprogramImg(url) {
      const a = document.createElement("a");
      if (url && url.indexOf("?") > -1) {
        a.href = `${url}&response-content-type=application/octet-stream`;
      } else {
        a.href = `${url}?response-content-type=application/octet-stream`;
      }
      a.download = "mp-qrcode.png";
      a.target = "_blank";
      a.click();
    },
    getMpQrcodePosterImg(url, shortLinkQrCode) {
      const imgPath = shortLinkQrCode.replace(/^https?\:\/\/img\.hetao101\.com\//, "");
      console.log("imgPath ", imgPath);
      const qrcode = `${imgPath}?x-oss-process=image/resize,w_${186},h_${186}`;
      const posterimg = `image_${encode(qrcode)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/\=/g, "")},g_se,x_55,y_34`;
      return `${url}?x-oss-process=image/resize,w_750/watermark,${posterimg}`;
    },
    // 下载
    exportExcel(type, batchNo) {
      if (!navigator.onLine) {
        this.alertBox("网络异常，请检查网络");
        return;
      }
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.6)"
      });
      const baseParams = {
        batchNo,
        teamCode: getTeamCode()
      };
      const batchParams = {
        ...this.listQuery,
        teamCode: getTeamCode(),
        agentCode: getAgentCode(),
        linkStatus: this.linkStatus,
        teamRole: getTeamRole() ? Number(getTeamRole()) : 0,
        showDeleted: this.showDeleted
      };
      exportExcel({
        params: type === "batchQrcode" ? delUndefined(batchParams) : delUndefined(baseParams),
        apiPath: type === "batchQrcode" ? "agent/link/list/qrcode" : "agent/link/list/excelByBatchNo"
      }).then(res => {
        if (res.data && res.data.errCode && Number(res.data.errCode) > 0) {
          this.loading.close();
          this.alertBox(`导出失败${res.data.errMsg ? `，${res.data.errMsg}` : ""}`);
          return;
        }
        if (res.data && res.data.type && res.data.type === "application/json") {
          this.loading.close();
          const fr = new FileReader();
          fr.onload = e => {
            const result = e && e.target && e.target.result ? JSON.parse(e.target.result) : null;
            this.alertBox(`导出失败${result && result.errMsg ? `，${result.errMsg}` : ""}`);
          };
          fr.readAsText(res.data);
          return;
        }
        if (res) {
          setTimeout(() => {
            this.loading.close();
          }, 1000);
          const blob = new Blob([res]);
          const downloadElement = document.createElement("a");
          const objectUrl = window.URL.createObjectURL(blob); // 创建下载的链接
          downloadElement.href = objectUrl;
          downloadElement.download = type === "batchQrcode" ? `推广二维码.zip` : `推广链接汇总表.csv`; // 下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); // 点击下载
          document.body.removeChild(downloadElement); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl);
        }
      });
    },
    changeLinkStatus(e) {
      this.linkStatus = e;
      this.listQuery.pageSize = 10;
      this.listQuery.pageNumber = 1;
      this.getList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async enablePromotedLinks(row) {
      const userRole = Number(getTeamRole());
      console.log(userRole);
      if (userRole !== 1 && userRole !== 2) {
        this.$confirm("请联系渠道创建者恢复！", "启用", {
          showCancelButton: false,
          showConfirmButton: false,
          type: "warning"
        });
        return;
      }
      this.$confirm("是否要启用?", "启用", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          const { id } = row;
          const res = await enablePromotedLinks({ id });
          const { data } = res;
          if (data.errCode === 0) {
            this.linkStatus = "1";
            this.listQuery.pageSize = 10;
            this.listQuery.pageNumber = 1;
            this.getList();
            this.$message({
              type: "success",
              message: "启用成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: data.errMsg
            });
          }
        } catch (error) {
          this.$message({
            type: "error",
            message: error
          });
        }
      });
    },
    batchDeactivatePromotedLinks() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          type: "info",
          message: "请选择要停用的链接"
        });
        return
      }
      this.$confirm("是否批量停用", "停用", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          const ids = this.multipleSelection.map((item, index) => { return item.id }).join(',')
          const res = await batchDeactivatePromotedLinks({ ids });
          const { data } = res;
          if (data.errCode === 0) {
            this.linkStatus = "0";
            this.listQuery.pageSize = 10;
            this.listQuery.pageNumber = 1;
            this.getList();
            this.$message({
              type: "success",
              message: "批量停用成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: data.errMsg
            });
          }
        } catch (error) {
          this.$message({
            type: "error",
            message: error
          });
        }
      });
    },
    deactivatePromotedLinks(row) {
      this.$confirm("停用后链接将失效", "停用", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          const { id } = row;
          const res = await deactivatePromotedLinks({ id });
          const { data } = res;
          if (data.errCode === 0) {
            this.linkStatus = "0";
            this.listQuery.pageSize = 10;
            this.listQuery.pageNumber = 1;
            this.getList();
            this.$message({
              type: "success",
              message: "停用成功!"
            });
          } else {
            this.$message({
              type: "error",
              message: data.errMsg
            });
          }
        } catch (error) {
          this.$message({
            type: "error",
            message: error
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../styles/common.less";
.exportExcel {
  float: right;
  margin-top: 3px;
}
.distributorList {
  .showRemoved {
    float: right;
    margin-top: -35px;
  }
  .btnStyle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: center;
    color: #ff9900;
  }
  .filter-item-new,
  .qrcode-style {
    display: inline-block;
  }
  .qrcode-style {
    vertical-align: top;
    margin-top: 12px;
  }
  .qrcode_box {
    li {
      width: 200px;
      float: left;
      text-align: center;
    }
  }
  .poster_img {
    height: 150px;
    padding-top: 12px;
    display: block;
    margin: 0 auto 18px;
  }
  .save-img {
    clear: both;
    margin: 12px auto;
    padding: 0 20px;
    display: inline-block;
    background: #fe9400;
    color: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    line-height: 32px;
  }
  .btns-style {
    float: right;
    .btn {
      margin-top: 3px;
      margin-right: -5px;
    }
    .down-code {
      margin-top: 3px;
      margin-left: 10px;
      float: right;
    }
  }
  .selectWidth {
    width: 300px;
  }
  .inputWidth {
    width: 380px;
  }
  .blue {
    display: inline-block;
    color: #409eff;
    line-height: 22px;
    margin-top: 8px;
  }
  .toPosition {
    cursor: pointer;
    color: #ff9900;
  }
  .red {
    color: red;
    margin-left: 10px;
  }
  .attention {
    margin-left: 35px;
    i {
      font-size: 18px;
      vertical-align: top;
      margin: 6px;
    }
  }
}
.mp-container {
  // padding: 10px 0;
  background: rgba(242, 242, 242, 1);
  font-size: 12px;
}
</style>
<style>
.btnFalses,
.btnClose {
  color: #fff !important;
  background-color: #fe9400 !important;
  border-color: #fe9400 !important;
}
</style>
